import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { ZSpinner } from '@marageti/z4-lib';
import { SalesRecording } from '@marageti/z4-sdk/lib/travel';
import SalesTable from './sales-table';

type Props = {
  isLoading: boolean;
  sales: SalesRecording[] | undefined;
  totalSales: string | number | undefined;
  totalCommission: string | number | undefined;
};

const SalesView = ({
  isLoading,
  sales,
  totalSales,
  totalCommission,
}: Props) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        pt: { desktop: 4.5, mobile: 6.5 },
        pb: 20,
        maxWidth: { desktop: 'desktop' },
        margin: { desktop: '0 auto 56px' },
      }}
    >
      <Stack spacing={5}>
        <Stack direction={{ desktop: 'row' }} justifyContent="space-between" alignItems={{ desktop: 'center' }}>
          <Typography variant="h2" sx={{ mb: { mobile: 3, desktop: 'none' } }}>
            Sales
          </Typography>
        </Stack>
        {(!isLoading && sales?.length === 0) ? (
          <Card>
            <CardContent>
              <Typography variant="body" color="primary.light" textAlign="center">
                There are no sales recordings for the selected trip match.
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <>
            <Stack direction={{ desktop: 'row' }} spacing={2.5}>
              <Card sx={{ flex: 1, mb: { mobile: 3, desktop: 'none' } }}>
                {isLoading ? (
                  <Skeleton variant="rounded" height={116} />
                ) : (
                  <>
                    <CardHeader title={totalSales} titleTypographyProps={{ variant: 'display' }} />
                    <CardContent sx={{ pt: 0 }}>
                      <Typography variant="caption">
                        Total Trip Price (
                        {sales?.[0]?.price.currencyCode}
                        )
                      </Typography>
                    </CardContent>
                  </>
                )}
              </Card>
              <Card sx={{ flex: 1 }}>
                {isLoading ? (
                  <Skeleton variant="rounded" height={116} />
                ) : (
                  <>
                    <CardHeader title={totalCommission} titleTypographyProps={{ variant: 'display' }} />
                    <CardContent sx={{ pt: 0 }}>
                      <Typography variant="caption">
                        Total Zicasso Commission (
                        {sales?.[0]?.commission.currencyCode}
                        )
                      </Typography>
                    </CardContent>
                  </>
                )}
              </Card>
            </Stack>

            {isLoading ? (
              <Stack>
                <ZSpinner />
              </Stack>
            ) : (
              <SalesTable
                sales={sales || []}
                totalCommission={totalCommission}
                totalSales={totalSales}
              />
            )}

          </>
        )}
      </Stack>
    </Box>
  </Container>
);

export default SalesView;
